module.exports = __webpack_public_path__ + "static/img/tu3@2x.397cec04.png";